module.exports = __webpack_public_path__ + "img/fayou-bg.2c5329f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/login/fayou-bg.png
// module id = hKou
// module chunks = 157 158